import React from 'react';
import { Navigate } from 'react-router-dom';
import type { SubscriptionInfo } from '../../Shared/types';

interface SubscriptionGuardProps {
  subscription: SubscriptionInfo | null | undefined;
  children: React.ReactNode;
}

const SubscriptionGuard: React.FC<SubscriptionGuardProps> = ({ subscription, children }) => {
  if (subscription?.is_restricted === true) {
    return <Navigate to="/billing/pricing" replace />;
  }

  return <>{children}</>;
};

export default SubscriptionGuard;
